import React from "react"
import { Button } from "../ui/button"
import { useNavigate } from "react-router-dom"

interface Props {
  coachPublicProfileData: any
}

const SelfEnrollBlockModal: React.FC<Props> = ({
  coachPublicProfileData,
}) => {
  const navigate = useNavigate()
  const endpointSlug = coachPublicProfileData?.endpoint_slug
  const returnToWebsite = () => navigate(`/providers/${endpointSlug}`)

  return (
    <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center zoee-backdrop-filter z-[1009]">
      <div className="w-[800px] max-w-[90%] main-shadow rounded-[16px] pt-[40px] pb-[40px] max-h-[85vh] bg-white fixed left-[50%] -translate-x-[50%] flex flex-col items-start">
        <div className="flex w-full flex-col items-center text-center px-8 mt-6">
          <h2 className="text-2xl font-bold mb-3">
            You can’t enroll in your own service
          </h2>

          <p className="text-graySlate text-md max-w-[600px] mt-2">
            This service belongs to your account, so enrollment isn’t available
            here.
          </p>
          <p className="text-graySlate text-md max-w-[600px] mt-2">
            {" "}
            To manage or preview your services, return to your public page.
          </p>
        </div>

        <div className="flex w-full justify-center items-center mt-8 gap-4">
          <Button variant="default" size="lg" onClick={returnToWebsite}>
            Return to your website
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SelfEnrollBlockModal
